<button *ngIf="control.valueChanges | async" type="button" mat-icon-button (click)="control.reset()">
  <mat-icon>close</mat-icon>
</button>
